const autoNgTemplateLoaderTemplate1 = require('./por-access-management-users-selector.html');

export const porAccessManagementUsersSelector = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    options: '<',
    value: '=',
  },
};
